var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.activityLogTitle,
        size: "md",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "use-panel": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "eal-dialog" }, [
        _c("div", { staticClass: "eal-header" }, [
          _c("span", { staticClass: "eal-student-name" }, [
            _vm._v(_vm._s(_vm.studentName)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "eal-filter" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "140px" },
                attrs: {
                  placeholder: "Hành động",
                  size: "small",
                  clearable: "",
                },
                on: { change: _vm.fetchLogs },
                model: {
                  value: _vm.filterAction,
                  callback: function ($$v) {
                    _vm.filterAction = $$v
                  },
                  expression: "filterAction",
                },
              },
              [
                _c("el-option", { attrs: { label: "Tất cả", value: "" } }),
                _c("el-option", {
                  attrs: { label: "Tạo mới", value: "CREATE" },
                }),
                _c("el-option", {
                  attrs: { label: "Chỉnh sửa", value: "UPDATE" },
                }),
                _c("el-option", { attrs: { label: "Xoá", value: "DELETE" } }),
                _vm.periodic
                  ? _c("el-option", {
                      attrs: { label: "Duyệt", value: "APPROVE" },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "eal-timeline",
          },
          [
            _vm.logs.length === 0 && !_vm.loading
              ? _c("div", { staticClass: "eal-empty" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _c("span", [_vm._v("Chưa có lịch sử hoạt động")]),
                ])
              : _vm._e(),
            _vm._l(_vm.logs, function (log, idx) {
              return _c("div", { key: idx, staticClass: "eal-log-item" }, [
                _c("div", {
                  staticClass: "eal-log-dot",
                  class: _vm.actionDotClass(log.action),
                }),
                _c("div", { staticClass: "eal-log-content" }, [
                  _c(
                    "div",
                    { staticClass: "eal-log-text" },
                    [
                      _c("span", { staticClass: "eal-log-actor" }, [
                        _vm._v(_vm._s(log.actorName)),
                      ]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type: _vm.roleTagType(log.actorRole),
                          },
                        },
                        [_vm._v(_vm._s(_vm.roleLabel(log.actorRole)))]
                      ),
                      _c("span", [
                        _vm._v(
                          "đã " +
                            _vm._s(_vm.actionLabel(log.action)) +
                            " " +
                            _vm._s(_vm.typeLabel(log.evaluationType))
                        ),
                      ]),
                      log.evaluationType === "REPLY" && log.parentEvaluationType
                        ? _c("span", { staticClass: "eal-log-parent" }, [
                            _vm._v(
                              "\n              cho " +
                                _vm._s(
                                  _vm.typeLabel(log.parentEvaluationType)
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "eal-log-meta" }, [
                    _c("span", { staticClass: "eal-log-time" }, [
                      _vm._v(_vm._s(_vm.formatTimestamp(log.timestamp))),
                    ]),
                    log.evaluationType === "WEEKLY" && log.weekNumber
                      ? _c("span", { staticClass: "eal-log-date" }, [
                          _vm._v(
                            "\n              · Tuần " +
                              _vm._s(log.weekNumber) +
                              " (" +
                              _vm._s(_vm.formatDate(log.evaluationDate)) +
                              " – " +
                              _vm._s(_vm.formatDate(log.toDate)) +
                              ")\n            "
                          ),
                        ])
                      : log.evaluationDate
                      ? _c("span", { staticClass: "eal-log-date" }, [
                          _vm._v(
                            "\n              · Ngày: " +
                              _vm._s(_vm.formatDate(log.evaluationDate)) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }